/** 这里播放器组件比较特殊,没有专门的路由,也就是说,它会作为一个全局性的组件存在*/
import React, { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  changePlayingState,
  changeShowPlayList,
  changeCurrentIndex,
  changeCurrentSong,
  changePlayList,
  changePlayMode,
  changeFullScreen
} from "./store/actionCreators";

import MiniPlayer from './miniPlayer';
import NormalPlayer from './normalPlayer';
import {findIndex, getSongUrl, isEmptyObject, shuffle} from "../../api/utils";
import Toast from "./../../baseUI/toast";
import {playMode} from "../../api/config";
import PlayList from './play-list/index';
import {getLyricRequest} from "../../api/request";
import Lyric from './../../api/lyric-parser';
import { changeSpeed } from './store/actionCreators';

function Player (props) {
  //目前播放时间
  const [currentTime, setCurrentTime] = useState(0);
  //歌曲总时长
  const [duration, setDuration] = useState(0);
  //歌曲播放进度
  const percent = isNaN(currentTime / duration) ? 0 : currentTime / duration;

  const [preSong, setPreSong] = useState({}); //记录当前的歌曲,以便于下次重渲染时比对是否是一首歌
  const [modeText, setModeText] = useState("");
  const songReady = useRef (true);

  const toastRef = useRef();
  const audioRef = useRef();
  // 歌词
  const currentLyric = useRef ();

  //对于歌词功能，已经有了一个 currentLyric 对象，但同时我们还有一条即时歌词，因此要再声明一个 currentPlayingLyric 变量:
  const [currentPlayingLyric, setPlayingLyric] = useState ("");
  //一个记录当前行数的 currentLineNum:
  const currentLineNum = useRef (0);

  const {
    playing,
    currentSong:immutableCurrentSong,
    currentIndex,
    playList:immutablePlayList,
    mode,//播放模式
    sequencePlayList:immutableSequencePlayList,//顺序列表
    fullScreen,
    speed
  } = props;
  const {
    togglePlayingDispatch,
    changeCurrentIndexDispatch,
    changeCurrentDispatch,
    changePlayListDispatch,//改变playList
    changeModeDispatch,//改变mode
    toggleFullScreenDispatch,
    togglePlayListDispatch,
    changeSpeedDispatch
  } = props;

  const playList = immutablePlayList.toJS();
  const sequencePlayList = immutableSequencePlayList.toJS();
  const currentSong = immutableCurrentSong.toJS();

  //<audio ref={audioRef} onTimeUpdate={updateTime} onEnded={handleEnd} onError={handleError}></audio>
  const handleEnd = () => {
    if (mode === playMode.loop) {
      handleLoop();
    } else {
      handleNext();
    }
  };

  const changeMode = () => {
    let newMode = (mode + 1) % 3;
    if (newMode === playMode.sequence) {
      //顺序模式
      changePlayListDispatch(sequencePlayList);
      let index = findIndex(currentSong, sequencePlayList);
      changeCurrentIndexDispatch(index);
      setModeText("顺序循环");
    } else if (newMode === playMode.loop) {
      //单曲循环
      changePlayListDispatch(sequencePlayList);
      setModeText("单曲循环");
    } else if (newMode === playMode.random) {
      //随机播放
      let newList = shuffle(sequencePlayList);
      let index = findIndex(currentSong, newList);
      changePlayListDispatch(newList);
      changeCurrentIndexDispatch(index);
      setModeText("随机播放");
    }
    changeModeDispatch(newMode);
    toastRef.current.show();
  };

  const clickPlaying = (e, state) => {
    e.stopPropagation();
    togglePlayingDispatch(state);

    //歌曲暂停 / 播放时也要通知歌词
    if (currentLyric.current) {
      currentLyric.current.togglePlay(currentTime*1000);
    }
  };

  const updateTime = e => {
    setCurrentTime(e.target.currentTime);
  };

  const onProgressChange = curPercent => {
    const newTime = curPercent * duration;
    setCurrentTime(newTime);
    audioRef.current.currentTime = newTime;
    if (!playing) {
      togglePlayingDispatch(true);
    }

    if (currentLyric.current) {
      currentLyric.current.seek(newTime * 1000);
    }
  };

  const handleLoop = () => {
    audioRef.current.currentTime = 0;
    changePlayingState(true);
    currentLyric.current && currentLyric.current.seek(0)
    audioRef.current.play();
  };

  const handlePrev = () => {
    console.log('handlePrev');
    //播放列表只有一首歌时单曲循环
    if (playList.length === 1) {
      handleLoop();
      return;
    }
    let index = currentIndex - 1;
    if (index < 0) index = playList.length - 1;
    if (!playing) togglePlayingDispatch(true);
    changeCurrentIndexDispatch(index);
  };

  const handleNext = () => {
    //播放列表只有一首歌时单曲循环
    if (playList.length === 1) {
      handleLoop();
      return;
    }
    let index = currentIndex + 1;
    if (index === playList.length) index = 0;
    if (!playing) togglePlayingDispatch(true);
    changeCurrentIndexDispatch(index);
  };

  const handleLyric = ({lineNum, txt}) => {
    if (!currentLyric.current) return;
    currentLineNum.current = lineNum;
    setPlayingLyric(txt);
  };

  const getLyric = id => {
    let lyric = "";
    if (currentLyric.current) {
      currentLyric.current.stop();
    }
    // 避免songReady恒为false的情况
    setTimeout(() => {
      songReady.current = true;
    }, 3000);
    getLyricRequest(id)
      .then (data => {
        console.log('getLyricRequest data:',data);
        lyric = data.lrc.lyric;
        if (!lyric) {
          currentLyric.current = null;
          return;
        }
        currentLyric.current = new Lyric(lyric, handleLyric, speed);
        currentLyric.current.play();
        currentLineNum.current = 0;
        currentLyric.current.seek(0);
      })
      .catch (() => {
        currentLyric.current = "";
        songReady.current = true;
        audioRef.current.play();
      });
  };

  //↓ 真正的播放和暂停在这里处理的
  useEffect(() => {
    playing ? audioRef.current.play() : audioRef.current.pause();
  }, [playing]);

  //切换歌曲 和 初次播放都在这
  useEffect(() => {
    if (
      !playList.length ||
      currentIndex === -1 ||
      !playList[currentIndex] ||
      playList[currentIndex].id === preSong.id||
      !songReady.current// 标志位为 false
    ) return;

    let current = playList[currentIndex];
    changeCurrentDispatch(current);//赋值currentSong
    setPreSong(current);
    songReady.current = false; // 把标志位置为 false,表示现在新的资源没有缓冲完成,不能切歌
    audioRef.current.src = getSongUrl(current.id);
    audioRef.current.autoplay = true;
    // 这里加上对播放速度的控制
    audioRef.current.playbackRate = speed;
    setTimeout(() => {
      audioRef.current.play().then(()=>{
        songReady.current = true;
      });
    });
    togglePlayingDispatch(true);//播放状态
    getLyric(current.id);
    setCurrentTime(0);//从头开始播放
    setDuration((current.dt / 1000) | 0/**←向下取整*/);//时长
  }, [playList, currentIndex]);

  const clickSpeed = (newSpeed) => {
    changeSpeedDispatch(newSpeed);
    //playbackRate 为歌词播放的速度，可修改
    audioRef.current.playbackRate = newSpeed;
    // 别忘了同步歌词
    currentLyric.current.changeSpeed(newSpeed);
    currentLyric.current.seek(currentTime * 1000);
  };

  const handleError = () => {
    songReady.current = true;
    alert ("emmm,播放出错了");
  };

  return (
    <div>
      { isEmptyObject(currentSong) ? null :
        <MiniPlayer
          song={currentSong}
          fullScreen={fullScreen}
          playing={playing}
          toggleFullScreen={toggleFullScreenDispatch}
          clickPlaying={clickPlaying}
          percent={percent}
          togglePlayList={togglePlayListDispatch}
        />
      }
      { isEmptyObject(currentSong) ? null :
        <NormalPlayer
          song={currentSong}
          fullScreen={fullScreen}
          playing={playing}
          duration={duration}//总时长
          currentTime={currentTime}//播放时间
          percent={percent}//进度
          toggleFullScreen={toggleFullScreenDispatch}
          clickPlaying={clickPlaying}
          onProgressChange={onProgressChange}
          handlePrev={handlePrev}
          handleNext={handleNext}
          mode={mode}
          changeMode={changeMode}
          togglePlayList={togglePlayListDispatch}
          currentLyric={currentLyric.current}
          currentPlayingLyric={currentPlayingLyric}
          currentLineNum={currentLineNum.current}
          clickSpeed={clickSpeed}
        />
      }
      <audio
        ref={audioRef}
        onTimeUpdate={updateTime}
        onEnded={handleEnd}
        onError={handleError}
      ></audio>
      <PlayList clearPreSong={setPreSong.bind(null, {})}></PlayList>
      <Toast text={modeText} ref={toastRef}></Toast>
    </div>
  )
}

// 映射 Redux 全局的 state 到组件的 props 上
const mapStateToProps = state => ({
  fullScreen: state.getIn (["player", "fullScreen"]),
  playing: state.getIn (["player", "playing"]),
  currentSong: state.getIn (["player", "currentSong"]),
  showPlayList: state.getIn (["player", "showPlayList"]),
  mode: state.getIn (["player", "mode"]),
  currentIndex: state.getIn (["player", "currentIndex"]),
  playList: state.getIn (["player", "playList"]),
  sequencePlayList: state.getIn (["player", "sequencePlayList"]),
  speed: state.getIn (["player", "speed"]),
});

// 映射 dispatch 到 props 上
const mapDispatchToProps = dispatch => {
  return {
    togglePlayingDispatch (data) {
      dispatch (changePlayingState (data));
    },
    toggleFullScreenDispatch (data) {
      dispatch (changeFullScreen (data));
    },
    togglePlayListDispatch (data) {
      dispatch (changeShowPlayList (data));
    },
    changeCurrentIndexDispatch (index) {
      dispatch (changeCurrentIndex (index));
    },
    changeCurrentDispatch (data) {
      dispatch (changeCurrentSong (data));
    },
    changeModeDispatch (data) {
      dispatch (changePlayMode (data));
    },
    changePlayListDispatch (data) {
      dispatch (changePlayList (data));
    },
    changeSpeedDispatch (data) {
      dispatch (changeSpeed (data));
    }
  };
};

// 将 ui 组件包装成容器组件
export default connect (
  mapStateToProps,
  mapDispatchToProps
)(React.memo (Player));
